import { alpha } from '@mui/material/styles';
import type { ClosingCtaStyles, LandingTokens } from '../types';
import { BREAKPOINTS, down } from './breakpoints';

export const closingCtaStyles = (t: LandingTokens): ClosingCtaStyles => ({
  section: {
    position: 'relative',
    overflow: 'hidden',
    background: [
      `radial-gradient(900px 480px at 15% 120%, ${alpha(t.brand, 0.3)}, transparent 60%)`,
      'linear-gradient(180deg, #101820, #0d141a)',
    ].join(', '),
    color: t.onDark,
    textAlign: 'center',
    padding: '110px 0 116px',
    marginTop: '40px',
    [down(BREAKPOINTS.mobile)]: { padding: '76px 0 80px' },
  },
  headline: {
    fontFamily: t.serif,
    fontWeight: 380,
    fontSize: 'clamp(34px, 4.6cqi, 54px)',
    lineHeight: 1.08,
    letterSpacing: '-.01em',
    maxWidth: '18ch',
    margin: '0 auto 18px',
  },
  subtext: {
    color: alpha(t.onDark, 0.65),
    maxWidth: '52ch',
    margin: '0 auto 36px',
    fontSize: '16.5px',
  },
  ctaRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '14px',
    flexWrap: 'wrap',
  },
});
